import { styled } from '@mui/material/styles';
import Popover, { popoverClasses } from '@mui/material/Popover';

export const SelectMenuRoot = styled(Popover, {
  name: 'AFSelectMenu'
})({
  [`& .${popoverClasses.paper}`]: {
    display: 'flex'
  }
});
